import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const session = sessionStorage.getItem("session");
  const sessionID = sessionStorage.getItem("sessionID");

  const isLoggedIn = session && sessionID;

  return isLoggedIn ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
